 <section class="content">
        <div class="row">
            <div class="box  box-primary">
                <PageHeader  [showNote]="false" [showMainListing]="false" [showAddNew]="false"
                    [showSearch]="false" [showSave]="true" 
                    [showDelete]="false" #pageheader class="pageHeaderButtonPosition"
                    [title]="'Inventory Settings'"></PageHeader>

                <div class="clearfix"></div>
                <div class="box"  style="border-top: 0px !important">
                    <div class="box-body">

                        <div class="box ibox box-info">
                        <div class="panel panel-default" style="margin-top: 6px;">
                            <div class="panel-heading" role="tab" id="dmReference">
                                <h4 class="panel-title">
                                <div class="box-header with-border" style="padding:0px;">
                                    <h3 class="box-title">Organization-wise Minimum Part Quantity</h3>
                                </div>
                                </h4>
                            </div>
                        </div>
                        <div class="box-body">
                               <div class="table-center">
                                    <table class="table table-bordered table-condensed fixed-table text-center">
                                        <colgroup>
                                        <col style="width: 25%">
                                        <col style="width: 25%">
                                        <col style="width: 40%">
                                        </colgroup>

                                        <thead>
                                        <tr>
                                            <th>Qty1</th>
                                            <th>Qty2</th>
                                            <th>User</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr>
                                            <td>
                                            <input type="text" class="form-control" placeholder="Enter Qty 1" (keypress)="numberOnly($event)">
                                            </td>
                                            <td>
                                            <input type="text" class="form-control" placeholder="Enter Qty 2" (keypress)="numberOnly($event)">
                                            </td>
                                            <td>
                                            <select class="form-control">
                                                <option value="">Select User</option>
                                                <option *ngFor="let user of userList" [value]="user.id">
                                                    {{ user.givenname }}  {{user.familyname}}
                                                </option>
                                            </select>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                        </div>

                        <div class="panel panel-default" style="margin-top: 6px;">
                            <div class="panel-heading" role="tab" id="dmReference">
                                <h4 class="panel-title">
                                <div class="box-header with-border" style="padding:0px;">
                                    <h3 class="box-title">Division-wise Minimum Part Quantity</h3>
                                </div>
                                </h4>
                            </div>
                        </div>
                    <div class="box-body">
                        <div class="table-center">
                            <table class="table table-bordered table-condensed">
                            <colgroup>
                                <col style="width: 25%">
                                <col style="width: 25%">
                                <col style="width: 25%">
                                <col style="width: 25%">
                            </colgroup>
                            <thead>
                                <tr>
                                <th>Division</th>
                                <th>Qty1</th>
                                <th>Qty2</th>
                                <th>User</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let division of divisions">
                                <!-- Division -->
                                <td style="font-weight: 500;">
                                    {{ division }}
                                </td>

                                <!-- Min Part Qty 1 -->
                                <td>
                                    <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Qty 1"
                                    (keypress)="numberOnly($event)">
                                </td>

                                <!-- Min Part Qty 2 -->
                                <td>
                                    <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Qty 2"
                                    (keypress)="numberOnly($event)">
                                </td>

                                <!-- User Dropdown -->
                                <td>
                                    <select class="form-control">
                                    <option value="">Select User</option>
                                    <option *ngFor="let user of userList" [value]="user.id">
                                        {{ user.givenname }}   {{user.familyname}}
                                    </option>
                                    </select>
                                </td>
                                </tr>
                            </tbody>
                            </table>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                 <PageHeader [menuMode]="true"  [showNote]="false" [showMainListing]="false" [showAddNew]="false"
                    [showSearch]="false" [showSave]="true" 
                    [showDelete]="false" #pageheader></PageHeader>
            </div>
        </div>
 </section>